module.exports = __webpack_public_path__ + "img/logotipo.74ec477e.png";